import React from 'react';

import { Text } from '@/components/text';
import { tv } from '@/utils/styles';

export interface JourneyTextBlockProps {
  primaryText?: string;
  subText?: string;
}

const JourneyTextBlock = ({ primaryText, subText }: JourneyTextBlockProps) => {
  const { base, primary, sub } = styles();
  return (
    <div className={base()}>
      <Text className={primary()}>{primaryText}</Text>
      <Text className={sub()}>{subText}</Text>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'flex flex-col items-start py-1',
    sub: 'mb-0 mt-2 text-sm text-text-secondary',
    primary: 'm-0 text-baseSm font-medium leading-4 text-text-primary',
  },
});

export { JourneyTextBlock };
